import { Home } from '@lmc/ts-common'
import { Text } from '@lmc/ui-kit/src/general'
import { Divider, Popover } from 'antd'
import { getNominative } from 'common/utils'
import { NAMESPACE } from 'locale'
import { accessControlConstants } from 'locale/accessControl'
import { lowerCase } from 'lodash'
import { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

interface RotaBasedAccessPopoverProps {
  children: ReactNode
}

const RotaBasedAccessPopover = ({ children }: RotaBasedAccessPopoverProps) => {
  const { t } = useTranslation(NAMESPACE.ACCESS_CONTROL)

  const [isOpen, setIsOpen] = useState(false)

  const preferredPeopleNominative: string = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.preferredPeopleNominative || '',
  )
  const peopleNominative = getNominative(preferredPeopleNominative, 'Residents')

  const handleOpenChange = (newOpen: boolean) => {
    setIsOpen(newOpen)
  }
  return (
    <Popover
      placement="bottom"
      showArrow
      arrow={{ pointAtCenter: true }}
      trigger="hover"
      open={isOpen}
      onOpenChange={handleOpenChange}
      content={
        <Container>
          <Header>
            <Text weight="bold">
              {t(accessControlConstants.WHAT_IS_ROTA_BASED_ACCESS)}
            </Text>
            <StyledDivider />
          </Header>
          <Text>
            {t(accessControlConstants.ROTA_BASED_ACCESS_EXPLANATION, {
              nominative: lowerCase(peopleNominative),
            })}
          </Text>
        </Container>
      }
    >
      {children}
    </Popover>
  )
}

export default RotaBasedAccessPopover

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 250px;
  color: ${({ theme }) => theme.color.neutral.color3};
`
const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
const StyledDivider = styled(Divider)`
  margin: 0;
`
